import { LegendResponse } from '../actions/legend';

export const mockLegendResponse: LegendResponse = {
  externalSources: [],
  layerCategories: [
    {
      name: 'Network',
      layers: [
        {
          name: 'Network',
          year: 2024,
          key: 0,
          subCategories: [],
          enabled: true,
          endPoint: 'network/sections/geo',
        },
      ],
    },
    {
      name: 'Assets',
      layers: [
        {
          name: 'Lighting Point',
          year: 2024,
          key: 1,
          subCategories: ['Electrical'],
          enabled: false,
          endPoint: 'api/assets/types/LP/assets/geo',
        },
        {
          name: 'Electrical Test',
          year: 2024,
          key: 2,
          subCategories: ['Electrical'],
          enabled: false,
          endPoint: 'api/assets/types/TEX/assets/geo',
        },
        {
          name: 'Electrical Test2',
          year: 2024,
          key: 3,
          subCategories: ['Electrical'],
          enabled: false,
          endPoint: 'api/assets/types/TEX/assets/geo',
        },
        {
          name: 'Electrical Test3',
          year: 2024,
          key: 4,
          subCategories: ['Electrical'],
          enabled: false,
          endPoint: 'api/assets/types/TEX/assets/geo',
        },
      ],
    },
  ],
};
